import { usePetitionGuidesPageData } from 'src/app/pages/petitionGuidesArticle/pageContext';

type Result = ModelHookResult<{
	canonicalUrl: string;
	description: string | null;
	baseUrl: string;
	title: string;
	image?: string;
	hrefLangSlugs: Array<{ locale: string; slug: string }>;
	defaultHrefLangSlug: { locale: string; slug: string } | undefined;
}>;

export function usePageMeta(): Result {
	const {
		data: {
			article: { slug, subheading, heading, heroImage, localeSlugs },
		},
	} = usePetitionGuidesPageData();

	let hrefLangSlugs = [] as Array<{ locale: string; slug: string }>;

	if (localeSlugs) {
		for (const { locales, slug: localeSlug } of localeSlugs) {
			for (const locale of locales) {
				hrefLangSlugs.push({ locale, slug: localeSlug });
			}
		}
	}

	const defaultHrefLangSlug = hrefLangSlugs.find(({ locale }) => locale === 'en-US');

	hrefLangSlugs = hrefLangSlugs.filter(({ locale }) => !locale.includes('en-'));

	return {
		data: {
			canonicalUrl: `https://www.change.org/petition-guides/${slug}`,
			baseUrl: 'https://www.change.org/petition-guides/',
			description: subheading,
			title: heading,
			image: heroImage?.url,
			hrefLangSlugs,
			defaultHrefLangSlug,
		},
	};
}
